import { j as T } from "./jsx-runtime-B6kdoens.js";
import Oe, { useCallback as we, useRef as fe, useEffect as me, useMemo as ce } from "react";
import { c as Z, a as Ne } from "./index-CROKJrb5.js";
import { c as H, f as J } from "./create-component-CBAeEoQ6.js";
import { useTabsState as je } from "./react/Tabs/TabsState/index.js";
import { w as he } from "./atom-provider-B3P183Tj.js";
import { createAccordionState as Me, AccordionContext as Pe, useAccordionStateAtoms as Ae } from "./react/Accordion/AccordionState/index.js";
import { a as Se, u as se } from "./use-sync-atom-value-CDr7vapO.js";
import { AccordionContent as Ie } from "./react/Accordion/AccordionContent/index.js";
import { AccordionSummary as _e } from "./react/Accordion/AccordionSummary/index.js";
import "./react/Banner/index.js";
import "./react/Breadcrumbs/index.js";
import "./react/Button/index.js";
import "./react/DatePicker/index.js";
import "./react/Card/index.js";
import "./react/Card/CardImage/index.js";
import "./react/Card/CardContent/index.js";
import "./react/Card/CardFooter/index.js";
import "./react/Card/CardMeta/index.js";
import "./react/Card/CardPricing/index.js";
import "./react/Card/CardRating/index.js";
import "./react/Card/CardTags/index.js";
import "./react/Card/BeforeAfterCard/index.js";
import "./react/Card/BeforeAfterCard/BeforeAfterCardContent/index.js";
import "./react/Card/BeforeAfterCard/BeforeAfterCardImages/index.js";
import "./react/Card/BeforeAfterCard/BeforeAfterCardMeta/index.js";
import "./react/Card/ControlCard/index.js";
import "./react/Card/ControlCard/ControlCardContent/index.js";
import "./react/Card/ControlCard/ControlCardRadioButton/index.js";
import "./react/Card/ControlCard/ControlCardRadioButtonGroup/index.js";
import "./react/Card/ControlCard/ControlCardImage/index.js";
import "./react/Card/ControlCard/ControlCardTitle/index.js";
import "./CardContext-B6h__heb.js";
import "./react/Card/MediaCard/index.js";
import "./react/Card/MediaCard/MediaCardContent/index.js";
import "./react/Card/MediaCard/MediaCardMeta/index.js";
import "./react/Card/ProductCard/index.js";
import "./react/Card/ProductCard/ProductCardContent/index.js";
import "./react/Card/ProductCard/ProductCardImage/index.js";
import "./react/Card/TextCard/index.js";
import "./react/Card/TextCard/TextCardContent/index.js";
import "./react/Card/TextCard/TextCardLabels/index.js";
import "./react/Card/TextCard/TextCardMeta/index.js";
import "./react/Card/TextCard/TextCardPricing/index.js";
import "./react/Card/TextCard/TextCardTags/index.js";
import "./react/Card/TextCard/TextCardTitle/index.js";
import "./react/Carousel/index.js";
import "./react/Checkbox/index.js";
import "./react/Checkbox/CheckboxGroup/index.js";
import "./react/CodeInput/index.js";
import "./react/CookieConsentBanner/index.js";
import "./index-DG7OKFQx.js";
import "./react/Footer/index.js";
import "./react/Footer/FooterBody/index.js";
import "./react/Footer/FooterButton/index.js";
import "./react/Footer/FooterDetail/index.js";
import "./react/Footer/FooterDetails/index.js";
import "./react/Footer/FooterLink/index.js";
import "./react/Footer/FooterNav/index.js";
import "./react/Footer/FooterLogo/index.js";
import "./react/Footer/FooterNavColumn/index.js";
import "./react/Footer/FooterSocial/index.js";
import "./react/Footer/FooterSocialRow/index.js";
import { FormControl as ve } from "./react/FormControl/index.js";
import { useDecorationIconSize as be, FormControlDecoration as ue } from "./react/FormControl/FormControlDecoration/index.js";
import "./react/FormControl/FormControlGroup/index.js";
import { b as ge, F as ye } from "./FormControlContext-C7A4R-3o.js";
import "./react/FormControl/FormControlHelperText/index.js";
import "./react/FormControl/FormControlHighlight/index.js";
import "./react/FormControl/FormControlLabel/index.js";
import "./react/FormControl/FormControlRequired/index.js";
import "./models/index.ts.js";
import "./use-debounce-CdWiiBgU.js";
import { u as Ee } from "./use-unique-id-BA9hSqap.js";
import "./react/Highlight/index.js";
import { IconRenderer as pe } from "./react/Icon/index.js";
import "./react/Image/index.js";
import "./react/InteractiveList/index.js";
import "./react/InteractiveList/InteractiveListItem/index.js";
import { Label as Ve } from "./react/Label/index.js";
import "./react/Link/index.js";
import "./react/List/index.js";
import "./react/List/ListItem/index.js";
import "./react/List/ListItemIcon/index.js";
import "./react/ListHeader/index.js";
import { c as Re, g as ze } from "./_commonjsHelpers-DaMA6jEr.js";
import { ErrorIcon as De } from "./react/Icon/icons/ErrorIcon/index.js";
import { u as xe } from "./use-merge-refs-DEJnLwh4.js";
import "./react/Modal/index.js";
import "./react/Modal/ModalContent/index.js";
import "./react/Modal/ModalFooter/index.js";
import "./react/Modal/ModalHeader/index.js";
import "./react/Navigation/index.js";
import "./react/Navigation/NavigationBar/index.js";
import "./react/Navigation/NavigationBrand/index.js";
import "./react/Navigation/NavigationCta/index.js";
import "./react/Navigation/NavigationDropdown/index.js";
import "./react/Navigation/NavigationDropdown/NavigationDropdownItem/index.js";
import "./react/Navigation/NavigationDropdown/NavigationDropdownContent/index.js";
import "./react/Navigation/NavigationDropdown/NavigationDropdownMenu/index.js";
import "./react/Navigation/NavigationFull/index.js";
import "./react/Navigation/NavigationItem/index.js";
import "./react/Navigation/NavigationItemList/index.js";
import "./react/Navigation/NavigationMinimal/index.js";
import "./react/Navigation/NavigationMobileMenu/index.js";
import { u as de, c as Le, a as Be, N as $e } from "./index-g4ls63IB.js";
import { u as le, a as Fe, b as Ge } from "./react-B_GApDuV.js";
import { u as qe } from "./NavigationState-EOPjgMu1.js";
import { Typography as We } from "./react/Typography/index.js";
import "./react/NumberInput/index.js";
import "./react/Progress/index.js";
import "./react/RadioButton/index.js";
import "./react/RadioButton/RadioButtonGroup/index.js";
import "./react/Rating/index.js";
import { SelectOption as Ue } from "./react/SelectInput/SelectOption/index.js";
import { ChevronIcon as Ke } from "./react/Icon/icons/ChevronIcon/index.js";
import { LoadingIcon as Qe } from "./react/Icon/icons/LoadingIcon/index.js";
import { useBrand as Ce } from "./brand/context/index.js";
import "./react/Squeeze/index.js";
import "./react/Tabs/index.js";
import "./react/Tabs/TabContent/index.js";
import "./react/Tabs/TabsList/index.js";
import "./react/Tag/index.js";
import "./react/Tile/index.js";
import "./react/Tile/IngredientTile/index.js";
import "./react/Toast/index.js";
import "./react/Toast/ToastItem/index.js";
import "./react/Toast/ToastList/index.js";
import "./react/Toast/ToastRenderer/index.js";
import "./react/Toggle/index.js";
import "./react/Toggle/ToggleGroup/index.js";
import "./react/Tooltip/index.js";
import "./react/Tooltip/TooltipContent/index.js";
import "./react/Tooltip/TooltipTrigger/index.js";
const Xe = he(
  H(
    "Accordion",
    J(
      ({ as: v, children: N, defaultOpen: w, id: c, onToggle: t, open: o, size: s, type: u, ...m }, f) => {
        const x = v || "section", { openAtom: d, idAtom: p, onToggleAtom: O, sizeAtom: k, typeAtom: i } = Ae(), h = Ee("accordion", c);
        return Se(d, w), se(p, h), se(O, t), se(d, o), se(k, s), se(i, u), /* @__PURE__ */ T.jsx(x, { ref: f, id: h, ...m, children: N });
      }
    )
  ),
  Pe,
  Me
);
var ke = { exports: {} };
(function(v, N) {
  (function(w, c) {
    v.exports = c(Oe);
  })(Re, function(w) {
    return function(c) {
      function t(s) {
        if (o[s]) return o[s].exports;
        var u = o[s] = { exports: {}, id: s, loaded: !1 };
        return c[s].call(u.exports, u, u.exports, t), u.loaded = !0, u.exports;
      }
      var o = {};
      return t.m = c, t.c = o, t.p = "", t(0);
    }([function(c, t, o) {
      function s(l) {
        return l && l.__esModule ? l : { default: l };
      }
      function u(l, e) {
        var r = {};
        for (var n in l) e.indexOf(n) >= 0 || Object.prototype.hasOwnProperty.call(l, n) && (r[n] = l[n]);
        return r;
      }
      function m(l, e) {
        if (!(l instanceof e)) throw new TypeError("Cannot call a class as a function");
      }
      function f(l, e) {
        if (!l) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !e || typeof e != "object" && typeof e != "function" ? l : e;
      }
      function x(l, e) {
        if (typeof e != "function" && e !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
        l.prototype = Object.create(e && e.prototype, { constructor: { value: l, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(l, e) : l.__proto__ = e);
      }
      Object.defineProperty(t, "__esModule", { value: !0 }), t.conformToMask = void 0;
      var d = Object.assign || function(l) {
        for (var e = 1; e < arguments.length; e++) {
          var r = arguments[e];
          for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (l[n] = r[n]);
        }
        return l;
      }, p = /* @__PURE__ */ function() {
        function l(e, r) {
          for (var n = 0; n < r.length; n++) {
            var C = r[n];
            C.enumerable = C.enumerable || !1, C.configurable = !0, "value" in C && (C.writable = !0), Object.defineProperty(e, C.key, C);
          }
        }
        return function(e, r, n) {
          return r && l(e.prototype, r), n && l(e, n), e;
        };
      }(), O = o(3);
      Object.defineProperty(t, "conformToMask", { enumerable: !0, get: function() {
        return s(O).default;
      } });
      var k = o(11), i = s(k), h = o(9), a = s(h), b = o(5), S = s(b), j = o(2), _ = function(l) {
        function e() {
          var r;
          m(this, e);
          for (var n = arguments.length, C = Array(n), g = 0; g < n; g++) C[g] = arguments[g];
          var y = f(this, (r = e.__proto__ || Object.getPrototypeOf(e)).call.apply(r, [this].concat(C)));
          return y.setRef = y.setRef.bind(y), y.onBlur = y.onBlur.bind(y), y.onChange = y.onChange.bind(y), y;
        }
        return x(e, l), p(e, [{ key: "setRef", value: function(r) {
          this.inputElement = r;
        } }, { key: "initTextMask", value: function() {
          var r = this.props, n = this.props.value;
          this.textMaskInputElement = (0, S.default)(d({ inputElement: this.inputElement }, r)), this.textMaskInputElement.update(n);
        } }, { key: "componentDidMount", value: function() {
          this.initTextMask();
        } }, { key: "componentDidUpdate", value: function(r) {
          var n = this.props, C = n.value, g = n.pipe, y = n.mask, K = n.guide, M = n.placeholderChar, L = n.showMask, P = { guide: K, placeholderChar: M, showMask: L }, G = typeof g == "function" && typeof r.pipe == "function" ? g.toString() !== r.pipe.toString() : (0, j.isNil)(g) && !(0, j.isNil)(r.pipe) || !(0, j.isNil)(g) && (0, j.isNil)(r.pipe), R = y.toString() !== r.mask.toString(), $ = Object.keys(P).some(function(I) {
            return P[I] !== r[I];
          }) || R || G, B = C !== this.inputElement.value;
          (B || $) && this.initTextMask();
        } }, { key: "render", value: function() {
          var n = this.props, C = n.render, g = u(n, ["render"]);
          return delete g.mask, delete g.guide, delete g.pipe, delete g.placeholderChar, delete g.keepCharPositions, delete g.value, delete g.onBlur, delete g.onChange, delete g.showMask, C(this.setRef, d({ onBlur: this.onBlur, onChange: this.onChange, defaultValue: this.props.value }, g));
        } }, { key: "onChange", value: function(r) {
          this.textMaskInputElement.update(), typeof this.props.onChange == "function" && this.props.onChange(r);
        } }, { key: "onBlur", value: function(r) {
          typeof this.props.onBlur == "function" && this.props.onBlur(r);
        } }]), e;
      }(i.default.PureComponent);
      t.default = _, _.propTypes = { mask: a.default.oneOfType([a.default.array, a.default.func, a.default.bool, a.default.shape({ mask: a.default.oneOfType([a.default.array, a.default.func]), pipe: a.default.func })]).isRequired, guide: a.default.bool, value: a.default.oneOfType([a.default.string, a.default.number]), pipe: a.default.func, placeholderChar: a.default.string, keepCharPositions: a.default.bool, showMask: a.default.bool }, _.defaultProps = { render: function(l, e) {
        return i.default.createElement("input", d({ ref: l }, e));
      } };
    }, function(c, t) {
      Object.defineProperty(t, "__esModule", { value: !0 }), t.placeholderChar = "_", t.strFunction = "function";
    }, function(c, t, o) {
      function s() {
        var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : O, h = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : p.placeholderChar;
        if (!u(i)) throw new Error("Text-mask:convertMaskToPlaceholder; The mask property must be an array.");
        if (i.indexOf(h) !== -1) throw new Error(`Placeholder character must not be used as part of the mask. Please specify a character that is not present in your mask as your placeholder character.

` + ("The placeholder character that was received is: " + JSON.stringify(h) + `

`) + ("The mask that was received is: " + JSON.stringify(i)));
        return i.map(function(a) {
          return a instanceof RegExp ? h : a;
        }).join("");
      }
      function u(i) {
        return Array.isArray && Array.isArray(i) || i instanceof Array;
      }
      function m(i) {
        return typeof i == "string" || i instanceof String;
      }
      function f(i) {
        return typeof i == "number" && i.length === void 0 && !isNaN(i);
      }
      function x(i) {
        return typeof i > "u" || i === null;
      }
      function d(i) {
        for (var h = [], a = void 0; a = i.indexOf(k), a !== -1; ) h.push(a), i.splice(a, 1);
        return { maskWithoutCaretTraps: i, indexes: h };
      }
      Object.defineProperty(t, "__esModule", { value: !0 }), t.convertMaskToPlaceholder = s, t.isArray = u, t.isString = m, t.isNumber = f, t.isNil = x, t.processCaretTraps = d;
      var p = o(1), O = [], k = "[]";
    }, function(c, t, o) {
      function s() {
        var p = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : d, O = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : x, k = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        if (!(0, m.isArray)(O)) {
          if ((typeof O > "u" ? "undefined" : u(O)) !== f.strFunction) throw new Error("Text-mask:conformToMask; The mask property must be an array.");
          O = O(p, k), O = (0, m.processCaretTraps)(O).maskWithoutCaretTraps;
        }
        var i = k.guide, h = i === void 0 || i, a = k.previousConformedValue, b = a === void 0 ? d : a, S = k.placeholderChar, j = S === void 0 ? f.placeholderChar : S, _ = k.placeholder, l = _ === void 0 ? (0, m.convertMaskToPlaceholder)(O, j) : _, e = k.currentCaretPosition, r = k.keepCharPositions, n = h === !1 && b !== void 0, C = p.length, g = b.length, y = l.length, K = O.length, M = C - g, L = M > 0, P = e + (L ? -M : 0), G = P + Math.abs(M);
        if (r === !0 && !L) {
          for (var R = d, $ = P; $ < G; $++) l[$] === j && (R += j);
          p = p.slice(0, P) + R + p.slice(P, C);
        }
        for (var B = p.split(d).map(function(q, W) {
          return { char: q, isNew: W >= P && W < G };
        }), I = C - 1; I >= 0; I--) {
          var A = B[I].char;
          if (A !== j) {
            var Q = I >= P && g === K;
            A === l[Q ? I - M : I] && B.splice(I, 1);
          }
        }
        var z = d, X = !1;
        e: for (var U = 0; U < y; U++) {
          var te = l[U];
          if (te === j) {
            if (B.length > 0) for (; B.length > 0; ) {
              var oe = B.shift(), Y = oe.char, ie = oe.isNew;
              if (Y === j && n !== !0) {
                z += j;
                continue e;
              }
              if (O[U].test(Y)) {
                if (r === !0 && ie !== !1 && b !== d && h !== !1 && L) {
                  for (var ne = B.length, ee = null, F = 0; F < ne; F++) {
                    var re = B[F];
                    if (re.char !== j && re.isNew === !1) break;
                    if (re.char === j) {
                      ee = F;
                      break;
                    }
                  }
                  ee !== null ? (z += Y, B.splice(ee, 1)) : U--;
                } else z += Y;
                continue e;
              }
              X = !0;
            }
            n === !1 && (z += l.substr(U, y));
            break;
          }
          z += te;
        }
        if (n && L === !1) {
          for (var D = null, E = 0; E < z.length; E++) l[E] === j && (D = E);
          z = D !== null ? z.substr(0, D + 1) : d;
        }
        return { conformedValue: z, meta: { someCharsRejected: X } };
      }
      Object.defineProperty(t, "__esModule", { value: !0 });
      var u = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(p) {
        return typeof p;
      } : function(p) {
        return p && typeof Symbol == "function" && p.constructor === Symbol && p !== Symbol.prototype ? "symbol" : typeof p;
      };
      t.default = s;
      var m = o(2), f = o(1), x = [], d = "";
    }, function(c, t) {
      function o(m) {
        var f = m.previousConformedValue, x = f === void 0 ? u : f, d = m.previousPlaceholder, p = d === void 0 ? u : d, O = m.currentCaretPosition, k = O === void 0 ? 0 : O, i = m.conformedValue, h = m.rawValue, a = m.placeholderChar, b = m.placeholder, S = m.indexesOfPipedChars, j = S === void 0 ? s : S, _ = m.caretTrapIndexes, l = _ === void 0 ? s : _;
        if (k === 0 || !h.length) return 0;
        var e = h.length, r = x.length, n = b.length, C = i.length, g = e - r, y = g > 0, K = r === 0, M = g > 1 && !y && !K;
        if (M) return k;
        var L = y && (x === i || i === b), P = 0, G = void 0, R = void 0;
        if (L) P = k - g;
        else {
          var $ = i.toLowerCase(), B = h.toLowerCase(), I = B.substr(0, k).split(u), A = I.filter(function(V) {
            return $.indexOf(V) !== -1;
          });
          R = A[A.length - 1];
          var Q = p.substr(0, A.length).split(u).filter(function(V) {
            return V !== a;
          }).length, z = b.substr(0, A.length).split(u).filter(function(V) {
            return V !== a;
          }).length, X = z !== Q, U = p[A.length - 1] !== void 0 && b[A.length - 2] !== void 0 && p[A.length - 1] !== a && p[A.length - 1] !== b[A.length - 1] && p[A.length - 1] === b[A.length - 2];
          !y && (X || U) && Q > 0 && b.indexOf(R) > -1 && h[k] !== void 0 && (G = !0, R = h[k]);
          for (var te = j.map(function(V) {
            return $[V];
          }), oe = te.filter(function(V) {
            return V === R;
          }).length, Y = A.filter(function(V) {
            return V === R;
          }).length, ie = b.substr(0, b.indexOf(a)).split(u).filter(function(V, ae) {
            return V === R && h[ae] !== V;
          }).length, ne = ie + Y + oe + (G ? 1 : 0), ee = 0, F = 0; F < C; F++) {
            var re = $[F];
            if (P = F + 1, re === R && ee++, ee >= ne) break;
          }
        }
        if (y) {
          for (var D = P, E = P; E <= n; E++) if (b[E] === a && (D = E), b[E] === a || l.indexOf(E) !== -1 || E === n) return D;
        } else if (G) {
          for (var q = P - 1; q >= 0; q--) if (i[q] === R || l.indexOf(q) !== -1 || q === 0) return q;
        } else for (var W = P; W >= 0; W--) if (b[W - 1] === a || l.indexOf(W) !== -1 || W === 0) return W;
      }
      Object.defineProperty(t, "__esModule", { value: !0 }), t.default = o;
      var s = [], u = "";
    }, function(c, t, o) {
      function s(e) {
        return e && e.__esModule ? e : { default: e };
      }
      function u(e) {
        var r = { previousConformedValue: void 0, previousPlaceholder: void 0 };
        return { state: r, update: function(n) {
          var C = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : e, g = C.inputElement, y = C.mask, K = C.guide, M = C.pipe, L = C.placeholderChar, P = L === void 0 ? a.placeholderChar : L, G = C.keepCharPositions, R = G !== void 0 && G, $ = C.showMask, B = $ !== void 0 && $;
          if (typeof n > "u" && (n = g.value), n !== r.previousConformedValue) {
            (typeof y > "u" ? "undefined" : d(y)) === j && y.pipe !== void 0 && y.mask !== void 0 && (M = y.pipe, y = y.mask);
            var I = void 0, A = void 0;
            if (y instanceof Array && (I = (0, h.convertMaskToPlaceholder)(y, P)), y !== !1) {
              var Q = f(n), z = g.selectionEnd, X = r.previousConformedValue, U = r.previousPlaceholder, te = void 0;
              if ((typeof y > "u" ? "undefined" : d(y)) === a.strFunction) {
                if (A = y(Q, { currentCaretPosition: z, previousConformedValue: X, placeholderChar: P }), A === !1) return;
                var oe = (0, h.processCaretTraps)(A), Y = oe.maskWithoutCaretTraps, ie = oe.indexes;
                A = Y, te = ie, I = (0, h.convertMaskToPlaceholder)(A, P);
              } else A = y;
              var ne = { previousConformedValue: X, guide: K, placeholderChar: P, pipe: M, placeholder: I, currentCaretPosition: z, keepCharPositions: R }, ee = (0, i.default)(Q, A, ne), F = ee.conformedValue, re = (typeof M > "u" ? "undefined" : d(M)) === a.strFunction, D = {};
              re && (D = M(F, x({ rawValue: Q }, ne)), D === !1 ? D = { value: X, rejected: !0 } : (0, h.isString)(D) && (D = { value: D }));
              var E = re ? D.value : F, q = (0, O.default)({ previousConformedValue: X, previousPlaceholder: U, conformedValue: E, placeholder: I, rawValue: Q, currentCaretPosition: z, placeholderChar: P, indexesOfPipedChars: D.indexesOfPipedChars, caretTrapIndexes: te }), W = E === I && q === 0, V = B ? I : b, ae = W ? V : E;
              r.previousConformedValue = ae, r.previousPlaceholder = I, g.value !== ae && (g.value = ae, m(g, q));
            }
          }
        } };
      }
      function m(e, r) {
        document.activeElement === e && (_ ? l(function() {
          return e.setSelectionRange(r, r, S);
        }, 0) : e.setSelectionRange(r, r, S));
      }
      function f(e) {
        if ((0, h.isString)(e)) return e;
        if ((0, h.isNumber)(e)) return String(e);
        if (e == null) return b;
        throw new Error(`The 'value' provided to Text Mask needs to be a string or a number. The value received was:

 ` + JSON.stringify(e));
      }
      Object.defineProperty(t, "__esModule", { value: !0 });
      var x = Object.assign || function(e) {
        for (var r = 1; r < arguments.length; r++) {
          var n = arguments[r];
          for (var C in n) Object.prototype.hasOwnProperty.call(n, C) && (e[C] = n[C]);
        }
        return e;
      }, d = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
        return typeof e;
      } : function(e) {
        return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      };
      t.default = u;
      var p = o(4), O = s(p), k = o(3), i = s(k), h = o(2), a = o(1), b = "", S = "none", j = "object", _ = typeof navigator < "u" && /Android/i.test(navigator.userAgent), l = typeof requestAnimationFrame < "u" ? requestAnimationFrame : setTimeout;
    }, function(c, t) {
      function o(u) {
        return function() {
          return u;
        };
      }
      var s = function() {
      };
      s.thatReturns = o, s.thatReturnsFalse = o(!1), s.thatReturnsTrue = o(!0), s.thatReturnsNull = o(null), s.thatReturnsThis = function() {
        return this;
      }, s.thatReturnsArgument = function(u) {
        return u;
      }, c.exports = s;
    }, function(c, t, o) {
      function s(u, m, f, x, d, p, O, k) {
        if (!u) {
          var i;
          if (m === void 0) i = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
          else {
            var h = [f, x, d, p, O, k], a = 0;
            i = new Error(m.replace(/%s/g, function() {
              return h[a++];
            })), i.name = "Invariant Violation";
          }
          throw i.framesToPop = 1, i;
        }
      }
      c.exports = s;
    }, function(c, t, o) {
      var s = o(6), u = o(7), m = o(10);
      c.exports = function() {
        function f(p, O, k, i, h, a) {
          a !== m && u(!1, "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        }
        function x() {
          return f;
        }
        f.isRequired = f;
        var d = { array: f, bool: f, func: f, number: f, object: f, string: f, symbol: f, any: f, arrayOf: x, element: f, instanceOf: x, node: f, objectOf: x, oneOf: x, oneOfType: x, shape: x, exact: x };
        return d.checkPropTypes = s, d.PropTypes = d, d;
      };
    }, function(c, t, o) {
      c.exports = o(8)();
    }, function(c, t) {
      var o = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
      c.exports = o;
    }, function(c, t) {
      c.exports = w;
    }]);
  });
})(ke);
var Ze = ke.exports;
const He = /* @__PURE__ */ ze(Ze), Te = Z({
  base: "cur-transition-all cur-flex cur-items-start cur-relative",
  variants: {
    brand: {
      curology: null,
      agency: "cur-rounded-none"
    },
    size: {
      sm: "cur-gap-1",
      md: "cur-gap-2"
    },
    inGroup: {
      false: "cur-rounded-sm cur-border cur-bg-surface-neutral focus-within:cur-ring-2"
    },
    state: {
      "": null,
      // Adding classes here will not work without refactoring this value to be something other than an empty string
      critical: null,
      warning: null,
      success: null
    },
    disabled: {
      true: null,
      false: null
    }
  },
  compoundVariants: [
    {
      inGroup: !1,
      disabled: !1,
      state: "",
      className: "cur-border-border-subtle focus-within:cur-border-focus focus-within:cur-ring-focus"
    },
    {
      inGroup: !1,
      disabled: !1,
      state: "critical",
      className: "cur-border-border-error focus-within:cur-ring-border-error"
    },
    {
      inGroup: !1,
      disabled: !1,
      state: "warning",
      className: "cur-border-border-warning focus-within:cur-ring-border-warning"
    },
    {
      inGroup: !1,
      disabled: !1,
      state: "success",
      className: "cur-border-border-success focus-within:cur-ring-border-success"
    },
    {
      inGroup: !1,
      disabled: !0,
      className: "cur-border-border-disabled"
    },
    // AGENCY
    {
      inGroup: !1,
      brand: "agency",
      className: "cur-rounded-none"
    }
  ]
}), Je = Z({
  base: "cur-transition-all cur-flex cur-items-start cur-relative",
  variants: {
    size: {
      sm: "-cur-mt-1",
      md: "-cur-mt-2"
    }
  }
}), Ye = Z({
  base: "cur-w-full cur-font-body cur-outline-0 cur-transition-all cur-bg-transparent cur-flex-1 cur-leading-[1.25rem] cur-box-content",
  variants: {
    size: {
      sm: "cur-py-[.5625rem] cur-px-2",
      md: "cur-py-[1.0625rem] cur-px-3"
    },
    disabled: {
      true: "cur-text-disabled",
      false: "cur-text-primary"
    },
    resize: {
      false: "cur-resize-none"
    }
  }
}), er = (v, N, w) => N === "critical" ? /* @__PURE__ */ T.jsx(De, { size: w }) : /* @__PURE__ */ T.jsx(pe, { icon: v, size: w }), rr = H(
  "Text Input",
  J(
    ({
      as: v,
      children: N,
      className: w,
      defaultValue: c,
      disabled: t = !1,
      helperText: o,
      highlight: s,
      iconStart: u,
      iconEnd: m,
      id: f,
      label: x,
      multiline: d,
      onChange: p,
      placeholder: O,
      required: k,
      resize: i = !1,
      size: h,
      state: a,
      value: b,
      ...S
    }, j) => {
      const _ = Ce(), l = v || (d ? "textarea" : "input"), [e, r] = ge({
        defaultValue: c,
        disabled: t,
        id: f,
        resize: i,
        state: a,
        size: h,
        value: b,
        brand: _
      }), n = we(
        (M) => {
          const { value: L } = M.target;
          p == null || p(M, L), r((P) => ({ ...P, value: L }));
        },
        [p, r]
      ), C = be(h), g = c !== void 0, y = fe(), K = xe(j, y);
      return me(() => {
        const M = g ? y.current : void 0;
        return M == null || M.addEventListener(
          "input",
          n
        ), () => {
          M == null || M.removeEventListener(
            "input",
            n
          );
        };
      }, [g, n]), /* @__PURE__ */ T.jsx(ye.Provider, { value: e, children: /* @__PURE__ */ T.jsxs(
        ve,
        {
          className: w,
          fieldClassName: Te(e),
          helperText: o,
          highlight: s,
          highlightClassName: Je(e),
          label: x,
          required: k,
          size: h,
          children: [
            u ? /* @__PURE__ */ T.jsx(ue, { position: "start", children: er(u, a || "", C) }) : null,
            /* @__PURE__ */ T.jsx(
              l,
              {
                className: Ye(e),
                defaultValue: c || void 0,
                disabled: e.disabled,
                id: e.id,
                onChange: g ? void 0 : n,
                placeholder: O,
                ref: K,
                required: k,
                value: g ? void 0 : e.value,
                ...S
              }
            ),
            m ? /* @__PURE__ */ T.jsx(ue, { position: "end", children: /* @__PURE__ */ T.jsx(pe, { icon: m, size: C }) }) : null
          ]
        }
      ) });
    }
  )
), tr = He, or = H(
  "MaskedInput",
  J(
    ({ className: v, iconStart: N, iconEnd: w, multiline: c, resize: t, rows: o, ...s }, u) => /* @__PURE__ */ T.jsx(
      tr,
      {
        ...s,
        className: v,
        guide: !0,
        keepCharPositions: !1,
        placeholderChar: " ",
        ref: u,
        render: (m, { defaultValue: f, ...x }) => /* @__PURE__ */ T.jsx(
          rr,
          {
            ref: m,
            iconStart: N,
            iconEnd: w,
            multiline: c,
            resize: t,
            rows: o,
            defaultValue: f || "",
            ...x
          }
        )
      }
    )
  )
), nr = Z({
  base: "cur-w-full cur-text-left",
  variants: {
    depthGreaterThanOne: {
      true: "cur-pr-1"
    }
  }
}), ir = Z({
  variants: {
    depthEqualsOne: {
      true: "cur-flex cur-flex-col cur-gap-7 cur-py-3"
    },
    depthGreaterThanOne: {
      true: "cur-flex cur-flex-col cur-gap-0 cur-mt-2 -cur-mb-3"
    }
  }
}), ar = H(
  "NavigationMobileMenuAccordion",
  J(
    ({ as: v, children: N, className: w, nested: c, title: t, ...o }, s) => {
      const { depthAtom: u } = de(), m = le(u), f = m === 1, x = m > 1, d = nr({
        className: w,
        depthGreaterThanOne: x
      });
      if (v) {
        const p = v;
        return /* @__PURE__ */ T.jsx(p, { className: d, ref: s, ...o });
      }
      return /* @__PURE__ */ T.jsxs(
        Xe,
        {
          type: c ? "nested" : "default",
          ref: s,
          className: d,
          ...o,
          children: [
            /* @__PURE__ */ T.jsx(_e, { children: t }),
            /* @__PURE__ */ T.jsx(
              Ie,
              {
                className: ir({
                  depthEqualsOne: f,
                  depthGreaterThanOne: x
                }),
                children: N
              }
            )
          ]
        }
      );
    }
  )
), sr = (v) => {
  const { depthAtom: N } = de(), [w, c] = Ge(N);
  return me(() => {
    c(v + 1);
  }, [c, v]), w;
}, ur = he(
  H(
    "InnerNavigationMobileMenuItem",
    J(
      ({
        className: v,
        closeOnClick: N = !0,
        onClick: w,
        parentDepth: c,
        title: t,
        ...o
      }, s) => {
        const u = sr(c), m = !!o.children, { isMobileMenuOpenAtom: f } = qe(), x = Fe(f), d = Ne("cur-block cur-w-full cur-text-left", v);
        return m ? /* @__PURE__ */ T.jsx(
          ar,
          {
            className: d,
            nested: u > 1,
            ref: s,
            title: t,
            ...o
          }
        ) : /* @__PURE__ */ T.jsx(
          $e,
          {
            className: d,
            ref: s,
            title: t,
            onClick: (p) => {
              N && x(!1), w == null || w(p);
            },
            ...o
          }
        );
      }
    )
  ),
  Be,
  Le
), Go = H(
  "NavigationMobileMenuItem",
  J((v, N) => {
    const { depthAtom: w } = de(), c = le(w);
    return /* @__PURE__ */ T.jsx(
      ur,
      {
        parentDepth: c,
        ref: N,
        ...v
      }
    );
  })
), qo = (v, N = "nanp") => (v = v.replace(/\D/g, ""), N === "nanp" ? v.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3") : v.replace(/(\d{3})(\d{3})(\d{3})(\d{4})/, "+$1 $2 $3 $4")), lr = (v) => ce(() => v === "nanp" ? "(123) 456-7890" : "+001 234 567 8910", [v]), cr = (v) => ce(() => v === "nanp" ? [
  "(",
  /[1-9]/,
  /\d/,
  /\d/,
  ")",
  " ",
  /\d/,
  /\d/,
  /\d/,
  "-",
  /\d/,
  /\d/,
  /\d/,
  /\d/
] : [
  "+",
  /\d/,
  /\d/,
  /\d/,
  " ",
  /\d/,
  /\d/,
  /\d/,
  " ",
  /\d/,
  /\d/,
  /\d/,
  " ",
  /\d/,
  /\d/,
  /\d/,
  /\d/
], [v]), Wo = H(
  "PhoneInput",
  J(
    ({ className: v, format: N = "nanp", ...w }, c) => /* @__PURE__ */ T.jsx(
      or,
      {
        ref: c,
        ...w,
        className: v,
        placeholder: lr(N),
        mask: cr(N)
      }
    )
  )
), pr = Z({
  base: "cur-w-full cur-font-body cur-outline-0 cur-transition-all cur-bg-transparent cur-appearance-none cur-basis-0 cur-grow cur-shrink cur-leading-[1.25rem] cur-text-primary",
  variants: {
    size: {
      sm: "cur-py-[.5625rem] cur-px-2",
      md: "cur-py-[1.0625rem] cur-px-3"
    },
    resize: {
      false: "cur-resize-none"
    },
    placeholder: {
      true: "cur-text-disabled"
    },
    disabled: {
      true: "cur-text-disabled"
    }
  }
}), Uo = H(
  "Select Input",
  J(
    ({
      children: v,
      className: N,
      defaultValue: w = "",
      disabled: c,
      helperText: t,
      icon: o,
      id: s,
      label: u,
      loading: m,
      onChange: f,
      placeholder: x,
      required: d,
      size: p = "md",
      state: O,
      value: k = "",
      ...i
    }, h) => {
      const a = Ce(), [b, S] = ge({
        disabled: c,
        id: s,
        state: O,
        size: p,
        value: k || w,
        brand: a
      }), j = ce(
        () => (e) => {
          var r;
          f == null || f(e, e.target.value), (r = b.onChange) == null || r.call(b, e, e.target.value), S((n) => ({
            ...n,
            value: e.target.value
          }));
        },
        [f, b, S]
      ), _ = pr({
        ...b,
        placeholder: b.value === "" && !!x
      }), l = be(p);
      return /* @__PURE__ */ T.jsx(ye.Provider, { value: b, children: /* @__PURE__ */ T.jsxs(
        ve,
        {
          className: N,
          fieldClassName: Te(b),
          helperText: t,
          label: u,
          required: d,
          size: p,
          children: [
            o ? /* @__PURE__ */ T.jsx(
              ue,
              {
                position: "start",
                className: "cur-self-center",
                children: /* @__PURE__ */ T.jsx(pe, { icon: o, size: l })
              }
            ) : null,
            m && /* @__PURE__ */ T.jsx("span", { className: "cur-absolute cur-left-1/2 cur-top-1/2 -cur-translate-x-1/2 -cur-translate-y-1/2", children: /* @__PURE__ */ T.jsx(Qe, { size: p, className: "cur-animate-spin" }) }),
            /* @__PURE__ */ T.jsxs(
              "select",
              {
                ref: h,
                id: b.id,
                disabled: b.disabled || m,
                value: b.value,
                required: d,
                className: _,
                onChange: j,
                ...i,
                children: [
                  x && !m ? /* @__PURE__ */ T.jsx(Ue, { value: "", disabled: !0, children: x }) : null,
                  v
                ]
              }
            ),
            /* @__PURE__ */ T.jsx(
              ue,
              {
                position: "end",
                className: "cur-pointer-events-none cur-absolute cur-right-0 cur-flex cur-h-full cur-items-center",
                as: "label",
                htmlFor: b.id,
                children: /* @__PURE__ */ T.jsx(Ke, { size: "sm", className: "cur-rotate-90" })
              }
            )
          ]
        }
      ) });
    }
  )
), dr = Z({
  base: "cur-font-bold cur-flex cur-items-center cur-border-b-2 cur-border-b-border-brand-light cur-transition-all [&:has(:focus-visible)]:cur-outline cur-outline-offset-1 cur-outline-2",
  variants: {
    isActive: {
      false: "hover:cur-border-b-brand cur-cursor-pointer",
      true: "cur-bg-surface-brand cur-border-b-highlight"
    },
    size: {
      sm: "cur-px-4 cur-h-6",
      md: "cur-px-7 cur-h-8",
      lg: "cur-px-7 cur-h-12"
    },
    tally: {
      true: ""
    }
  },
  compoundVariants: [
    {
      tally: !0,
      size: "sm",
      className: "cur-pr-1"
    },
    {
      tally: !0,
      size: "md",
      className: "cur-pr-1"
    },
    {
      tally: !0,
      size: "lg",
      className: "cur-pr-3"
    }
  ]
}), fr = Z({
  variants: {
    isActive: {
      false: "cur-text-brand cur-cursor-pointer",
      true: "cur-text-inverse"
    }
  }
}), mr = Z({
  variants: {
    size: {
      sm: "cur-ml-1 cur-h-3 cur-px-1",
      md: "cur-ml-2",
      lg: "cur-ml-2"
    }
  }
}), hr = (v) => v === "sm" ? "meta" : v === "md" ? "body" : "h2", Ko = H(
  "Tab",
  J(
    ({ active: v, as: N, className: w, href: c, tally: t, title: o, size: s, value: u, ...m }, f) => {
      const { activeAtom: x, setActiveItem: d, setItemValue: p, sizeAtom: O } = je(), k = le(O), i = s ?? k, h = fe(null), a = xe(f, h);
      u && p(u, h);
      const b = le(x), S = v ?? b === u, _ = N ?? (!!c ? "a" : "button");
      return /* @__PURE__ */ T.jsxs(
        _,
        {
          "aria-selected": S,
          className: dr({
            isActive: S,
            size: i,
            tally: !!t,
            className: w
          }),
          href: c,
          onKeyDown: (l) => {
            l.key === "ArrowLeft" ? d(-1) : l.key === "ArrowRight" && d(1);
          },
          onClick: () => {
            u && d(u);
          },
          ref: a,
          role: "tab",
          tabIndex: S ? 0 : -1,
          ...m,
          children: [
            /* @__PURE__ */ T.jsx(
              We,
              {
                weight: "bold",
                size: hr(i),
                className: fr({ isActive: S }),
                children: o
              }
            ),
            t && /* @__PURE__ */ T.jsx(
              Ve,
              {
                labelType: "tally",
                className: mr({ size: i }),
                children: t
              }
            )
          ]
        }
      );
    }
  )
);
export {
  Xe as A,
  or as M,
  ar as N,
  Wo as P,
  Uo as S,
  Ko as T,
  Go as a,
  rr as b,
  qo as f,
  Te as g
};
//# sourceMappingURL=index-9DupDvMa.js.map
